
import OParam from './OParam';

export default class OOutput extends OParam {
  constructor (ghOutputParam) {
    super();
    this.ghOutputParam = ghOutputParam;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/OOutput.js